<template>
    <div class="message waba-template-message">
        <div class="meta-header" v-if="getMetaText()">
            <i class="material-icons">info</i>
            {{ getMetaText() }}
        </div>
        <div class="header-text" v-if="meta.headerText">{{ meta.headerText }}</div>
        <div class="body">{{ meta.body }}</div>
        <div class="buttons" v-if="meta.buttons.length > 0">
            <div
                class="single-button"
                v-for="(button, i) in meta.buttons"
                :class="{ selected: false }"
                :key="button.id"
                @click=""
            >
                <div class="single-button-text" v-html="button.text" />
            </div>
        </div>
        <div class="footer" v-if="meta.footer">{{ meta.footer }}</div>
    </div>
</template>

<script>
import _ from "lodash";
import { mapState } from "vuex";

export default {
    name: "WABATemplateMessage",
    props: {
        data: {
            type: Object,
            required: true,
        },
        conversationId: {
            type: String,
            required: true,
        },
    },
    computed: {
        ...mapState({
            siteId: (state) => _.get(state.site.site, "_id"),
        }),
    },
    created() {
        const meta = this.getTemplateParameters(this.data.payload);
        this.meta = {
            body: meta.body,
            footer: meta.footer,
            headerText: meta.headerText,
            buttons: meta.buttons,
        };
    },
    data() {
        return {
            clickedButton: null,
            meta: {
                body: "",
                footer: "",
                headerText: "",
                buttons: [],
            },
        };
    },
    methods: {
        getMetaText() {
            let { fromBroadcast, fromAPI, fromAutomation, user, userId, username } = this.data;
            if (fromBroadcast) {
                return "This message sent from Broadcast";
            }
            if (fromAPI) {
                return "This message sent from API";
            }
            if (fromAutomation) {
                return "This message sent from Automation";
            }
            if (userId || user) {
                username = username || user.name;
                return `This Template Message sent from ${username}`;
            }
            return null;
        },
        getTemplateParameters(template) {
            const metaObject = JSON.parse(template.meta);
            const containerMetaObj = JSON.parse(template.containerMeta);

            let params = _.get(template, "params", []) || [];

            const bodyFromContainerMeta = _.get(containerMetaObj, "data");
            let body = bodyFromContainerMeta || _.get(metaObject, "example") || metaObject.data;
            let headerText = _.get(containerMetaObj, "header");
            let footer = _.get(containerMetaObj, "footer");
            if (typeof params === "string") {
                params = [params];
            }
            params = Array.isArray(params) ? params : [];
            if (params.length > 0) {
                //replace params with actual values ex: {{1}} => params[0] , {{2}} => params[1]
                for (let i = 0; i < params.length; i++) {
                    const param = params[i];
                    const regex = new RegExp(`\\{\\{${i + 1}\\}\\}`, "g");
                    body = body.replace(regex, param);
                    if (headerText) {
                        headerText = headerText.replace(regex, param);
                    }
                    if (footer) {
                        footer = footer.replace(regex, param);
                    }
                }
            }
            const buttons = _.get(containerMetaObj, "buttons") || template.buttons;
            console.log("getTemplateParameters", {
                template,
                metaObject,
                containerMetaObj,
                body,
                buttons,
                bodyFromContainerMeta,
                headerText,
                footer,
                params,
            });
            return {
                headerType: null, //text|image,
                headerMediaType: null, //image|video|document|location,
                headerMediaURL: null,
                headerText,
                footer,
                body,
                buttons: Array.isArray(buttons) && buttons.length > 0 ? buttons : [],
            };
        },
    },
};
</script>

<style lang="scss" scoped>
.message.waba-template-message {
    border: 1px solid;
    border-radius: 10px;
    overflow: hidden;
    width: 240px;
    border-color: rgb(219, 225, 232);
    background: rgb(255, 255, 255);

    .meta-header {
        padding: 3px;
        border-bottom: 1px solid #dbe1e8;
        font-size: 10px;
        background: #3f3f3fa1;
        color: white;
        display: flex;
        align-items: center;
        gap: 3px;

        .material-icons {
            font-size: 14px;
        }
    }

    .header-text,
    .body,
    .footer {
        background-color: #fff;
        border-radius: 4px;
        padding: 12px 8px;
    }

    .header-text {
        font-size: 16px;
        font-weight: 500;
        padding: 6px 7px 0px 9px;
        overflow-wrap: break-word;
    }

    .body {
        display: -webkit-box;
        font-size: 14px;
        font-weight: 400;
        color: rgb(63, 63, 63);
        overflow-wrap: break-word;
        word-break: break-word;
        max-width: 100%;
        overflow-y: auto;
        max-height: 400px;
        padding: 8px 8px 6px;
        white-space: pre-line;
    }

    .footer {
        font-size: 12px;
        font-weight: 500;
        line-height: 16px;
        padding: 0px 7px 8px 9px;
        color: rgb(95, 104, 128);
        overflow-wrap: break-word;
        word-break: break-word;
        display: -webkit-box;
        max-width: 100%;
        max-height: 48px;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-top: 4px;
    }

    .buttons {
        display: flex;
        flex-direction: column;
        width: 100%;

        .single-button {
            align-items: center;
            border-top: 1px solid;
            cursor: pointer;
            display: flex;
            font-weight: 600;
            min-height: 45px;
            padding: 0 10px;
            transition: all 0.3s;
            background: rgb(255, 255, 255);
            border-top-color: rgb(219, 225, 232);

            &.selected {
                background: rgb(0, 108, 255);

                .single-button-text {
                    color: white;
                }
            }

            &:hover {
                opacity: 0.8 !important;
            }

            .single-button-text {
                overflow: hidden !important;
                text-align: center;
                text-overflow: ellipsis;
                white-space: nowrap;
                width: 100%;
                color: rgb(0, 108, 255);
            }
        }
    }
}
</style>
